import EmbeddedContent from '@components/EmbeddedContent'
import config from '@config'
import {
  desktopCSS,
  regularMobileCSS,
  smallMobileCSS,
  tabletCSS,
} from '@measures/responsive'
import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import Sporttip from '@components/Sporttip'
import { SportradarProps, ValidSportradarProps } from './types'
import { isValidSportradarProps } from './utils'

type CreateEmbedUrlType = (
  ...args: [
    matchId: ValidSportradarProps['matchId'],
    brandedImageSrc: ValidSportradarProps['brandedImageSrc']
  ]
) => string

const {
  publication: { publication },
  sportradar: { sportradarStaticPageUrl },
} = config

const StyledSportradar = styled.div`
  ${desktopCSS(css`
    min-height: 492px;
  `)}
  ${tabletCSS(css`
    min-height: 522px;
  `)}
  ${smallMobileCSS(css`
    min-height: calc(100vw - 24px);
  `)}
  ${regularMobileCSS(css`
    min-height: 75vw;
  `)}
`
const StyledContainer = styled.div``

const createEmbeddedUrl: CreateEmbedUrlType = (matchId, brandedImageSrc) =>
  `${sportradarStaticPageUrl}?matchId=${matchId}&brandedImageSrc=${encodeURIComponent(
    brandedImageSrc
  )}`

const Sportradar: FunctionComponent<SportradarProps> = (props) => {
  if (!isValidSportradarProps(props)) {
    return null
  }

  const { matchId, brandedImageSrc, showSponsorBanner } = props

  const showSporttip = showSponsorBanner && publication !== 'romandie'

  return (
    <StyledContainer>
      <StyledSportradar>
        <EmbeddedContent
          maxHeight={500}
          url={createEmbeddedUrl(matchId, brandedImageSrc)}
        />
      </StyledSportradar>
      {showSporttip ? <Sporttip /> : null}
    </StyledContainer>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'sportradar'],
  component: Sportradar,
}

export default widget
